module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/85.43528a70.png";